import api from './api';

export const ownerViewingSlotsAPI = {
  list: (inquiryId) => api.get(`/owner/inquiries/${inquiryId}/viewing-slots`),
  create: (inquiryId, payload) => api.post(`/owner/inquiries/${inquiryId}/viewing-slots`, payload),
  cancel: (slotId) => api.delete(`/owner/viewing-slots/${slotId}`),
};
